import React, { Component } from "react";
import { Form, TimePicker } from "antd";
import { isMoment } from "moment";
import { InputNumber } from "../../../../../components/common/input-number";
import { InputNumberDouble } from "../../../../../components/common/input-number-double";
const { RangePicker } = TimePicker;

export class FirstHalfRates extends Component {
  render() {
    const { limitEdit, isEdit, isOwner, typeOption } = this.props;
    return (
      <>
        <div className="title-contract">
          7. Mức giá cho thuê và phụ phí đi kèm (Chưa VAT)*
        </div>
        <Form.Item wrapperCol={15} name={"CT001"} label={`+ Giá thuê tháng::`}>
          <InputNumber
            className={
              !isOwner && typeOption !== "create_new" ? "hidePrice" : ""
            }
            is_money
            disabled={!limitEdit || (typeOption !== "create_new" && !isOwner)}
            suffix={"VNĐ/xe"}
          />
        </Form.Item>
        <div className="sub-title">* Các phụ phí đi kèm</div>
        <Form.Item
          name="weekend_fee"
          rules={[
            {
              type: "object",
              message: "Bạn cần điền đẩy đủ phí cuối tuần",
            },
          ]}
          label={`+ Phí cuối tuần::`}
        >
          <InputNumberDouble
            typeOption={typeOption}
            isOwner={isOwner}
            disabled={!limitEdit}
            name="weekend_fee"
            onChangeForm={this.props.onChangeForm}
            feild1="CT014"
            disableSub={!isEdit}
            feild2="OLQ007"
          />
        </Form.Item>
        <Form.Item
          name={"holiday_fee"}
          rules={[{ type: "object" }]}
          label={`+ Phí ngày lễ::`}
        >
          <InputNumberDouble
            name="holiday_fee"
            typeOption={typeOption}
            isOwner={isOwner}
            disabled={!limitEdit}
            disableSub={!isEdit}
            onChangeForm={this.props.onChangeForm}
            feild1="CT005"
            feild2="OLQ006"
          />
        </Form.Item>
        <Form.Item
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Thời gian làm việc:</div>
            </div>
          }
          name={"works_time_holiday"}
          rules={[
            // {
            //   type: 'array',
            //   required: true,
            //   message: `Vui lòng nhập thời gian làm việc!`,
            // },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || value.length < 2) {
                  return Promise.reject("Vui lòng nhập thời gian làm việc!");
                }
                if (
                  value &&
                  value.length === 2 &&
                  isMoment(value[0]) &&
                  isMoment(value[1])
                ) {
                  const startUnix = value[0].unix();
                  const endUnix = value[1].unix();
                  if (endUnix - startUnix >= 14400) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "Thời gian kết thúc lớn hơn 4 giờ so với bắt đầu"
                  );
                }
              },
            }),
          ]}
        >
          <RangePicker
            disabled={!limitEdit}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            style={{ width: "100%" }}
            format="HH:mm"
          />
        </Form.Item>
      </>
    );
  }
}
